query GetAdminFeeSageJournalEntry($id: ID!) {
  adminFeeSageJournalEntry(id: $id) {
    id
    glJournalId
    description
    postingDate
    referenceNumber
    sageId
    lines {
      txnType
      txnAmount {
        minorUnit
        currency
      }
      description
      glAccountId
      locationId
      documentId
      projectId
      salesforceId
      caseRecordId
      caseStageSetToMoneyMovementAt
      caseStageSetToClosedAt
      classId
      departmentId
    }
    status
    errorMessage
    createdAt
    updatedAt
    journalEntryType
    sageHref
  }
}
